import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import { MenuItem as MenuItemProps } from "../../types/Menu";
import { Box } from "../Box";
import { DropRightMenuItem } from "../DropRightMenuItem";
import { MenuItemLink } from "../MenuItemLink";

interface Props {
  onMouseEnter?: Function;
  onMouseLeave?: Function;
}

const Content = styled(Box)<PositionProps>`
  ${position};
  display: none;
  z-index: 100;
`;

const HoverArea = styled(Box)`
  &:hover > ${Content} {
    display: block;
  }
  position: relative;
`;

export const NavDropDownItem: React.FC<Props & MenuItemProps> = ({ onMouseEnter, onMouseLeave, children, ...menuItem }) => (
  <HoverArea onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
    {children}
    <Content position="absolute" bg="white" borderRadius={5} maxWidth={200} minWidth={200} boxShadow="0px 0px 7px 0px rgba(0,0,0,0.47)">
      {menuItem.subMenu!.map(menu =>
        isEmpty(menu.subMenu) ? (
          <Box key={menu.title} py={2} px={3}>
            <MenuItemLink to={menu.url} color="primary" fontSize="14px" hover>
              {menu.title}
            </MenuItemLink>
          </Box>
        ) : (
          <Box key={menu.title} py={1}>
            <DropRightMenuItem {...menu} />
          </Box>
        ),
      )}
    </Content>
  </HoverArea>
);

NavDropDownItem.defaultProps = {
  subMenu: [],
};
